var GiftOccasionView = (function (elSelector, editOnly, _router) {

    var _template = 'bt-checkout-delivery-gift-occasion';

    var _formModes = {
        general: 1,
        edit: 2
    };

    var _giftOccasionView = Backbone.View.extend({
        el: elSelector + ' @giftOccasionEdit',

        events: {
            'change select': '_change'
        },

        initialize: function () {
            _.bindAll(this, '_render', '_change', '_setOccasion');
            this.model.on('change:GiftOccasionEdit', this._setOccasion);
            this._render();
        },

        _render: function() {
            var settings = CheckoutSettings.getBasketSettings() || {};
            var occasionsList = settings.GiftOccasions || [];

            this.$giftOccasion = this.$('@giftOccasion');

            this.$giftOccasion.append($('<option value></option>'));
            _.each(occasionsList, _.bind(function (occasion) {
                var option = $('<option value="' + occasion.Key + '" data-date="' + occasion.Value + '">' + occasion.Key + '</option>');
                if (occasion.Key === this.model.get('GiftOccasion')) {
                    option.attr('selected', true);
                }
                this.$giftOccasion.append(option);
            }, this));
        },

        _change: function (e) {
            if (!e) return;
            var el = $(e.currentTarget);
            var option = el.find('option:selected');

            var value = el.val();
            var dateValue = option.data('date');

            this.model.set('GiftOccasionEdit', value || null);

            if (dateValue && !this.model.get('GiftDateEditDay') && !this.model.get('GiftDateEditMonth') && !this.model.get('GiftDateEditYear')) {
                dateValue = dateValue.replace(/(\d\d)\/(\d\d)\/(\d\d\d\d)/, '$2/$1/$3');
                var tic = Date.parse(dateValue) || null;
                if (tic) {
                    var d = new Date(tic);
                    this.model.setGiftDateEdit(d.getDate(), d.getMonth() + 1, d.getFullYear());
                }
            }
        },

        _setOccasion: function(m) {
            this.$giftOccasion.find('option:selected').prop("selected", false);
            this.$giftOccasion.find('option[value=' + m.get('GiftOccasionEdit')  + ']').prop("selected", true);
        }
    });

    var _giftDateView = Backbone.View.extend({
        el: elSelector + ' @giftDateEdit',

        initialize: function () {
            _.bindAll(this, '_render', '_setDate');
            this._render();

            this.model.onGiftDateEditChange(_.bind(function (m) {
                this._setDate(m.getGiftDateEditObj());
            }, this));
        },

        _render: function () {

            this.dateSelector = app.GiftDateSelector(this.$el, true);
            this.dateSelector.init();
            this.dateSelector.onChange(_.bind(function (isValid, date, d) {
                this.model.setGiftDateEdit(d.day, d.month, d.year);
            }, this));

            this._setDate(this.model.getGiftDateEditObj());
        },

        _setDate: function (date) {
            if (date) {
                this.dateSelector.setDate(date);
            }
        }
    });

    var _view = Backbone.View.extend({
        el: elSelector,

        events: {
            'input textarea': '_change',
            'keyup textarea': '_change', // Only for <=IE9.
            'change textarea': '_change',
            'click @btnSaveGiftOccasion': 'save',
            'click @giftOccasionToggle': '_toggleFormMode'
        },

        initialize: function () {
            _.bindAll(this, '_render', '_update', 'save', '_change', '_saved', '_toggleDisplay', '_toggleFormMode', '_inProgress');

            if (_router) {
                _router && _router.onChangeActiveForm(_.bind(this._toggleDisplay, this));
                this._toggleDisplay(null, _router.getActiveForm());
            }

            this._render();

            this.model.on('change', this._update);
            this.model.onSaved(this._saved);
        },

        _toggleDisplay: function (e, form) {
            this.$el.toggleClass('hidden-block', form === 2);
        },

        _toggleFormMode: function () {
            if (this._formModes === _formModes.edit && this.model.get('GiftMessageEdit') !== this.model.get('GiftMessage')) {
                this.model.cancelMessageChanges();
            } else {
                this._toggle(this._formModes === _formModes.general ? _formModes.edit : _formModes.general);
            }
        },

        _render: function() {
            this.$el.prepend($.tmpl(_template, this.model.toJSON()));

            this.$giftOccasionToggle = this.$('@giftOccasionToggle');
            this.$giftOccasionToggle.toggleClass('hidden-block', editOnly === true);

            this.$btnSaveGiftOccasion = this.$('@btnSaveGiftOccasion');

            this.$giftMessageEditForm = this.$('@giftMessageEdit');
            this.$giftMessageGeneralForm = this.$('@giftMessageText');

            this.$giftOccasionGeneralForm = this.$('@giftOccasionText');
            this.$giftOccasionEditForm = this.$('@giftOccasionEdit');

            this.$giftDateEditForm = this.$('@giftDateEdit');
            this.$giftDateGeneralForm = this.$('@giftDateText');

            this.$txtMessage = this.$('#GiftMessage');
            this.$htmlMessage = this.$('#GiftMessageText');
            
            this.$giftOccasionText = this.$('#GiftOccasionText');
            this.$giftDateText = this.$('#GiftDateText');

            this.$giftLabel = this.$('@giftLabel');
            
            InitTooltip(this.$('@infoMessage'), 'GiftInfoMessageField');
            InitTooltip(this.$('@infoOccasion'), 'GiftInfoOccasionField');
            InitTooltip(this.$('@infoDate'), 'GiftInfoDateField');

            this._update();

            this._toggle(editOnly || !this.model.hasMessage() ? _formModes.edit : _formModes.general);
        },

        _toggle: function(mode) {
            if (mode) this._formModes = mode;

            this.$giftMessageEditForm.toggleClass('hidden-block', mode !== _formModes.edit);
            this.$giftOccasionEditForm.toggleClass('hidden-block', mode !== _formModes.edit);
            this.$giftDateEditForm.toggleClass('hidden-block', mode !== _formModes.edit);
            
            this.$giftMessageGeneralForm.toggleClass('hidden-block', mode !== _formModes.general);
            this.$giftOccasionGeneralForm.toggleClass('hidden-block', mode !== _formModes.general);
            this.$giftDateGeneralForm.toggleClass('hidden-block', mode !== _formModes.general);

            this.$btnSaveGiftOccasion.toggleClass('hidden-block', mode !== _formModes.edit);

            this.$giftOccasionToggle.toggleClass('hidden-block', editOnly);
            this.$giftOccasionToggle.removeClass(mode === _formModes.general ? 'cancel-icon' : 'change-icon');
            this.$giftOccasionToggle.addClass(mode === _formModes.general ? 'change-icon' : 'cancel-icon');

            this.$giftLabel.toggleClass('form-field-second_label__without-field', mode === _formModes.general);
        },

        _update: function () {
            this.$txtMessage.val(this.model.getGiftMessage());
            this.$htmlMessage.html(this.model.getGiftMessageHtml());

            var occasion = this.model.getGiftOccasion();
            this.$giftOccasionText.text(occasion || '');

            var date = this.model.getGiftDate();
            this.$giftDateText.text(date ? date.format('dd mmmm yyyy') : '');
        },

        _change: function(e) {
            this.model.set('GiftMessageEdit', e.currentTarget.value);
        },

        save: function(e) {
            e && e.preventDefault();
            this._inProgress(true);
            this.model.save()
                .fail(this._inProgress)
                .always(_.bind(function () {
                    this._inProgress(false);
                }, this));
        },

        _saved: function(data) {
            this.$txtMessage.val(data.GiftMessage);
            if (data.GiftMessage) {
                this.$htmlMessage.html('"' + data.GiftMessage.replace(/(?:\r\n|\r|\n)/g, '<br/>') + '"');
            } else {
                this.$htmlMessage.text('');
            }
            this._toggle(editOnly ? _formModes.edit : _formModes.general, !!data.GiftMessage);
        },

        _inProgress: function (state) {
            this.$btnSaveGiftOccasion.toggleClass('checkout-button-add-address', !state);
            this.$btnSaveGiftOccasion.toggleClass('checkout-button-add-address__processing', state);
        }
    });

    var mainView = new _view({ model: app.models.giftOccasion });
    var giftOccasionView = new _giftOccasionView({ model: app.models.giftOccasion });
    var giftDateView = new _giftDateView({ model: app.models.giftOccasion });

    return mainView;

});